const DETAIL_LABEL_I18N_KEYS = {
  NAME: 'detailLabel.name',
  Email: 'detailLabel.email',
  MUID: 'detailLabel.muid',
  CEP: 'detailLabel.cep',
  'Phone Number': 'detailLabel.phoneNumber',
  'Card NO.': 'detailLabel.cardNO',
  CPF: 'detailLabel.cpf',
  'CPF/CNPJ': 'detailLabel.cpfCnpj',
  'App Name': 'detailLabel.appName',
  'App ID': 'detailLabel.appId',
  'Merchant Reference': 'detailLabel.merchantReference',
  System: 'detailLabel.system',
  Resolution: 'detailLabel.resolution',
  Browser: 'detailLabel.browser',
  IP: 'detailLabel.ip',
}

export function translateDetailLabel (vm, label) {
  if (label == null || label === '') {
    return label
  }
  const key = DETAIL_LABEL_I18N_KEYS[label]
  return key ? vm.$t(key) : label
}
